export const UPDATE_GENERAL_COMPLETED_ISSUES_ACTION_SUBJECT = 'updateCompletedIssues';
export const UPDATE_GENERAL_COMPLETED_ISSUES_METRICS_KEY = 'update-completed-issues';
